import { render, staticRenderFns } from "./BeefCattleModal1.vue?vue&type=template&id=01e9bf76"
import script from "./BeefCattleModal1.vue?vue&type=script&lang=js"
export * from "./BeefCattleModal1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports